// Ultra-simple gallery system - automatically reads all images from folder

export const loadGalleryImages = async (galleryFolder) => {
	if (!galleryFolder) {
		return [];
	}

	try {
		// Load the automatically generated gallery list
		const listResponse = await fetch('/galleries/gallery-list.json');
		if (!listResponse.ok) {
			console.error('Gallery list not found. Run "npm run generate-galleries" to create it.');
			return [];
		}

		const galleryList = await listResponse.json();
		const images = galleryList[galleryFolder] || [];
		
		// Convert image filenames to gallery objects
		return images.map((filename, index) => ({
			id: `gallery-${index}`,
			src: `/galleries/${galleryFolder}/${filename}`,
			alt: `${galleryFolder} - ${filename.replace(/\.[^/.]+$/, "")}`, // Remove extension for alt text
			caption: `Event photo ${index + 1}`
		}));

	} catch (error) {
		console.error("Error loading gallery images:", error);
		return [];
	}
};